import CountFormat from "%/dynamic-component-editor/options/count-format";
import { formatNumber } from "%/dynamic-components/render-engine/helpers/number-format";

// Whole-number elements (like / comment / share counts, vote scores, episode
// and season numbers). Grouping only — no decimal places on a count.
export const CountElementMixin = {
  options: [CountFormat],
  data() {
    return {
      CountFormat,
    };
  },
  methods: {
    formattedCount(value) {
      return formatNumber(value, this.getOptionValue(CountFormat));
    },
  },
};
